<ng-container>
  <div
    class="container-stepper"
    *ngIf="dataBenefit.benefit === 'Salud y Dental'"
  >
    <div class="box-detail mt-3" *ngIf="dataBenefit.status !== 'Rechazada'">
      <div class="flex-column">
        <span class="copec-bold-16">Detalle</span>
        <span class="copec-lg-14 bckground-light mt-1"
          >Plazo estimado 3 días hábiles</span
        >
      </div>
      <div class="d-flex align-items-center">
        <button
          *ngIf="dataBenefit.status === 'Enviada'"
          class="button-style red-color copec-rg-14"
          (click)="cancelRequest(dataBenefit.idCode)"
        >
          Rechazar solicitud
        </button>
        <button
          class="button-style blue-color copec-bold-14"
          (click)="aproveRequest(dataBenefit.idCode)"
        >
          Aprobar solicitud
        </button>
      </div>
      <div *ngIf="openModal">
        <app-modal-reject
          [idCode]="idCode"
          (closeModalReject)="closeModal($event)"
        ></app-modal-reject>
      </div>
    </div>

    <!--If is status rejected-->
    <div *ngIf="dataBenefit.status === 'Rechazada'">
      <div class="mt-2 margin-left-text">
        <span class="copec-bold-16">Detalle</span>
      </div>
      <div class="alert-rejected mt-2">
        <div>
          <img src="/assets/icono-status/reject-status.svg" alt=""/>
          <span class="copec-rg-14 margin-left-text"
            >Tu solicitud presenta un error: Texto escrito o seleccionado por el
            perfil aprobador</span
          >
        </div>
        <button class="button-style2 button-isrejected copec-bold-14">
          Ver beneficio
        </button>
      </div>
    </div>
  </div>
  <app-status-requirement
    [status]="dataBenefit.status"
    [steps]="updateProgressSteps(dataBenefit.status)"
    [viewRequest]="dataBenefit.benefit"
    [dataTableRequest]="dataBenefit"
    [idSelection]="dataBenefit.idCode"
  ></app-status-requirement>

  <div *ngIf="dataBenefit.benefit === 'Salud y Dental'">
    <div class="box-detail-form">
      <div class="col-md-3 box-download">
        <div class="document-title">
          <span class="mrgn-button-document copec-bold-16"
            >Archivos adjuntos</span
          >
          <span class="mrgn-button-document copec-bold-14 blue-color-download"
            >Descargar todo</span
          >
        </div>
        <div class="document-download mrgn-button-document">
          <div>
            <img src="/assets/icono/document.svg" alt="" />
          </div>
          <div>
            <span>Formulario de postulación</span>
          </div>
          <div>
            <img class="blue-color" src="/assets/icono/download-icon.svg" alt=""/>
          </div>
        </div>
      </div>
      <div class="container-aditional-request col-md-9">
        <div class="mrgn-button-document copec-bold-16">
          Beneficiarios adicionales
        </div>
        <app-card-info-beneficiary></app-card-info-beneficiary>
      </div>
    </div>
  </div>
</ng-container>
